import React, {useEffect} from 'react';

/**
 * вызывает кастомные собтия один раз после загрузки внутренего компонента компонента
 * может в будущем учесть ожиданние асинхронных событий если не обходимо
 * */

const InitAfterRenderV1 = ({afterRender, children}: {
        afterRender?: () => void,
        children: React.ReactNode
    }
) => {

    useEffect(() => {
        afterRender?.();
    }, []);

    return (children);

}

export default InitAfterRenderV1;